import { useEffect } from "react";

const VERSION_POLL_INTERVAL_MS = 60_000;

type VersionResponse = {
  version: string;
};

export function useVersionCheck() {
  useEffect(() => {
    let currentVersion: string | null = null;

    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`);
        if (!res.ok) return;

        const data = (await res.json()) as VersionResponse;
        if (!data?.version) return;

        if (!currentVersion) {
          currentVersion = data.version;
          return;
        }

        if (data.version !== currentVersion) {
          showUpdateBanner();
        }
      } catch {
        // Silently ignore polling errors.
      }
    };

    const interval = setInterval(check, VERSION_POLL_INTERVAL_MS);
    check();

    return () => clearInterval(interval);
  }, []);
}

function showUpdateBanner() {
  if (document.getElementById("update-banner")) return;

  const banner = document.createElement("div");
  banner.id = "update-banner";
  banner.innerHTML = `
    <div style="position:fixed;bottom:24px;right:24px;background:#111;color:#fff;
    padding:16px 20px;border-radius:12px;z-index:9999;font-family:sans-serif;
    display:flex;align-items:center;gap:16px;box-shadow:0 8px 30px rgba(0,0,0,0.3)">
      🚀 A new version is available!
      <button id="update-now-button"
        style="background:#fff;color:#111;border:none;padding:8px 16px;
        border-radius:8px;font-weight:700;cursor:pointer">
        Update Now
      </button>
    </div>
  `;

  document.body.appendChild(banner);

  const updateButton = document.getElementById("update-now-button");
  updateButton?.addEventListener("click", () => window.location.reload());
}
